import styled from '@emotion/styled';
import Dynamic from '@base/Dynamic/Dynamic';
import Loader from '@educator/Composite/QuestionCreation/Loader';
import { WIDTH_MAX, WIDTH_MIN } from '@cont/Quiz/constants';
import { mediaQuery } from '@styles/index';
import Navigation from '../Navigation';
import useLanding from './useLanding';

const Modals = Dynamic(() => import('@cont/Quiz/Taking/Modals'));
const ObjectiveQuestionView = Dynamic(() =>
  import('@cont/Quiz/Taking/Objective/QuestionView')
);
const MwebQuestionView = Dynamic(() =>
  import('@cont/Quiz/Taking/QuizMweb/MwebQuestionView')
);
const MwebQuestionDetail = Dynamic(() =>
  import('@cont/Quiz/Taking/QuizMweb/MwebQuestionDetail')
);

const Wrapper = styled.div`
  min-width: ${WIDTH_MIN}px;
  max-width: ${WIDTH_MAX}px;
  height: 100vh;
  margin: auto;
  display: grid;
  grid-template-columns: 70% 30%;
  background-color: var(--color-base-0);
`;

const QuizTakingWeb = styled.div`
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

const QuizTakingMweb = styled.div`
  ${mediaQuery.aboveMobile} {
    display: none;
  }
`;

const TakingLanding = () => {
  const { hasFetchedQuizQuestions } = useLanding();

  if (!hasFetchedQuizQuestions) {
    return <Loader />;
  }

  return (
    <>
      <QuizTakingWeb>
        <Wrapper>
          <div>
            <ObjectiveQuestionView />
          </div>
          <Navigation />
        </Wrapper>
        <Modals />
      </QuizTakingWeb>
      <QuizTakingMweb>
        <MwebQuestionView />
        <MwebQuestionDetail />
      </QuizTakingMweb>
    </>
  );
};

export default TakingLanding;
